// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

// // Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyBhItQ8E_tvx7iekPxnxIzu8-04ZqrBr7E",
//   authDomain: "fabdiz-quote.firebaseapp.com",
//   projectId: "fabdiz-quote",
//   storageBucket: "fabdiz-quote.appspot.com",
//   messagingSenderId: "507957412117",
//   appId: "1:507957412117:web:874f6f67f175010a29291c",
//   measurementId: "G-5TDTGCDW81",
// };

// // Initialize Firebase (ensure it's not reinitialized)
// const app = initializeApp(firebaseConfig);

// // Firestore
// export const firestore = getFirestore(app); 

// // Authentication
// export const auth = getAuth(app);

// // Google Auth Provider
// const provider = new GoogleAuthProvider();
// provider.setCustomParameters({ prompt: "select_account" });

// export const signInWithGoogle = () => signInWithPopup(auth, provider);

// export default app;

///////////////////////////////////////////////////////////////////////////////////////

import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/database';


// Your web app's Firebase configuration my id 

// const config = {
//   apiKey: "AIzaSyCuI6EjBUXZz2mUlpSpdtiyKdoYZx7zt7E",
//   authDomain: "fabdiz-4a354.firebaseapp.com",
//   projectId: "fabdiz-4a354",
//   storageBucket: "fabdiz-4a354.appspot.com",
//   messagingSenderId: "815424291234",
//   appId: "1:815424291234:web:52528eb1b98180a2b3f2fb",
//   measurementId: "G-M98FHCZNEQ"
// };



// Your web app's Firebase configuration main id 
const config = {
  apiKey: "AIzaSyBhItQ8E_tvx7iekPxnxIzu8-04ZqrBr7E",
  authDomain: "fabdiz-quote.firebaseapp.com",
  projectId: "fabdiz-quote",
  storageBucket: "fabdiz-quote.appspot.com",
  messagingSenderId: "507957412117",
  appId: "1:507957412117:web:874f6f67f175010a29291c",
  measurementId: "G-5TDTGCDW81"
};


firebase.initializeApp(config);

export const firestore = firebase.firestore();
export const auth = firebase.auth();

// const db = firebase.firestore();
// export const storage = firebase.storage();

// export {auth,db,storage}


export default firebase;